import React, { useEffect, useState } from "react";
import Commongrid from "../../common/Commongrid";
import formatDateAndTime from "../../common/formatDateAndTime";
import { useNavigate } from "react-router-dom";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Box,
  Button,
  Collapse,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { Upload } from "lucide-react";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CloseIcon from "@mui/icons-material/Close";
import uploadmutiplefile from "../../common/Uploadmultplefile";
import { getVehicle } from "../../api/api";
import commonapihandler from "../../common/commonapihandler";
import toast from "react-hot-toast";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import RefreshIcon from "@mui/icons-material/Refresh";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const Mywindshield = ({ selectedRow }) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");
  const issueType = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.issueType;
  delete issueType?.inverted;
  const issueStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.issueStatus;
  const issuePriority = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.issuePriority;
  const navigate = useNavigate();
  const [totalCount, setTotalCount] = useState(0);
  const [myIssues, setMyIssuesDetails] = useState([]);
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 20,
  });
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({});
  const [vehicleFilterListings, setVehicleFilterListings] = useState([]);
  const [hideTextfields, setHideTestFields] = useState(false);
  const [uploadedImages, setUploadedImages] = useState(null);
  const [errors, setErrors] = useState({});
  const [vehicles, setVehicles] = useState([]);
  const [windShieldData, setWindShieldData] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [editWindShield, setEditWindShieldId] = useState(null);
  const [open, setOpen] = useState(false);

  const handleImageOpen = (img) => {
    setPreviewImage(img);
    setPreviewOpen(true);
  };

  function createData(
    id,
    attachments,
    glassPosition,
    actionType,
    initialCondition,
    damageLocation,
    oldPartNumber,
    newGlassId,
    replacementReason,
    costToCompany,
    sgst,
    cgst,
    totalTax,
    labourCost,
    totalCost,
    sgstPercentage,
    cgstPercentage,
    totalTaxPercentage,
    discountAmount,
    discountPercentage,
    createdAt,
  ) {
    return {
      id,
      attachments,
      glassPosition,
      actionType,
      initialCondition,
      damageLocation,
      oldPartNumber,
      newGlassId,
      replacementReason,
      costToCompany,
      sgst,
      cgst,
      totalTax,
      labourCost,
      totalCost,
      sgstPercentage,
      cgstPercentage,
      totalTaxPercentage,
      discountAmount,
      discountPercentage,
      createdAt,
    };
  }

  const generalInformationofBatteries = [
    {
      label: "New Glass Id",
      value: "newGlassId",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Old Part Number",
      value: "oldPartNumber",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Glass Position",
      value: "glassPosition",
      type: "dropdown",
      disabled: false,
      subCategory: [
        { key: "Front", value: "Front" },
        { key: "Back", value: "Back" },
      ],
    },
    {
      label: "Action Type",
      value: "actionType",
      type: "dropdown",
      disabled: false,
      subCategory: [
        { key: "Chip Repair", value: "Chip Repair" },
        { key: "Crack Repair", value: "Crack Repair" },
        { key: "Full Replacement", value: "Full Replacement" },
        { key: "Recalibration", value: "Recalibration" },
        { key: "Resealing", value: "Resealing" },
        { key: "Defogger Repair", value: "Defogger Repair" },
        { key: "Others", value: "Others" },
      ],
    },
    {
      label: "Initial Condition",
      value: "initialCondition",
      type: "dropdown",
      disabled: false,
      subCategory: [
        { key: "Intact", value: "Intact" },
        { key: "Chipped", value: "Chipped" },
        { key: "Cracked", value: "Cracked" },
        { key: "Shattered", value: "Shattered" },
        { key: "Leaking", value: "Leaking" },
        { key: "Defogger Malfunction", value: "Defogger Malfunction" },
        { key: "Others", value: "Others" },
      ],
    },
    {
      label: "Damage Location",
      value: "damageLocation",
      type: "dropdown",
      disabled: false,
      subCategory: [
        { key: "Driver Side", value: "Driver Side" },
        { key: "Passenger Side", value: "Passenger Side" },
        { key: "Center Top", value: "Center Top" },
        { key: "Center Bottom", value: "Center Bottom" },
        { key: "Full Glass", value: "Full Glass" },
        { key: "Defogger Grid Lines", value: "Defogger Grid Lines" },
        // { key: "Others", value: "Others" },
      ],
    },
    {
      label: "Replacement Reason",
      value: "replacementReason",
      type: "dropdown",
      disabled: false,
      subCategory: [
        { key: "Accident", value: "Accident" },
        { key: "Stone Impact", value: "Stone Impact" },
        { key: "Stress Crack", value: "Stress Crack" },
        { key: "Wear & Tear", value: "Wear & Tear" },
        { key: "Vandalism", value: "Vandalism" },
        // { key: "Others", value: "Others" },
      ],
    },
    // {
    //   label: "Installed Date",
    //   value: "installedDate",
    //   type: "date",
    //   disabled: false,
    //   subCategory: null,
    // },
    // {
    //   label: "Is Installed",
    //   value: "isInstalled",
    //   type: "dropdown",
    //   disabled: false,
    //   subCategory: [
    //     { key: "true", value: "True" },
    //     { key: "false", value: "False" },
    //   ],
    // },
    // {
    //   label: "Is Swapped",
    //   value: "isSwapped",
    //   type: "dropdown",
    //   disabled: false,
    //   subCategory: [
    //     { key: "true", value: "True" },
    //     { key: "false", value: "False" },
    //   ],
    // },
    // {
    //   label: "Swapped Old Vehicle no",
    //   value: "vehicleNo",
    //   type: "dropdown",
    //   disabled: false,
    //   subCategory:
    //     vehicles &&
    //     Object.entries(vehicles).map(([key, item]) => ({
    //       value: item?.licensePlate + "__" + item?.name, // or whatever property you want
    //       label: item?.id,
    //     })),
    // },
    // {
    //   label: "Issue Id",
    //   value: "issueId",
    //   type: "dropdown",
    //   disabled: false,
    //   subCategory:
    //     myIssues &&
    //     Object.entries(myIssues).map(([key, item]) => ({
    //       value: item?.code, // or whatever property you want
    //       label: item?.id,
    //     })),
    // },
    // {
    //   label: "Vendor Name",
    //   value: "vendorName",
    //   type: "text",
    //   disabled: false,
    //   subCategory: null,
    // },
    // {
    //   label: "Vendor Contact",
    //   value: "vendorContact",
    //   type: "text",
    //   disabled: false,
    //   subCategory: null,
    // },
    // {
    //   label: "Vendor Address",
    //   value: "vendorAddress",
    //   type: "text",
    //   disabled: false,
    //   subCategory: null,
    // },
    // {
    //   label: "Is Payment Pending",
    //   value: "isPaymentPending",
    //   type: "dropdown",
    //   disabled: false,
    //   subCategory: [
    //     { key: "true", value: "True" },
    //     { key: "false", value: "False" },
    //   ],
    // },
    {
      label: "Cost to Company",
      value: "costToCompany",
      type: "number",
      disabled: false,
      subCategory: null,
    },
    {
      label: "CGST Amount",
      value: "cgst",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "SGST Amount",
      value: "sgst",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Total Tax",
      value: "totalTax",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Labour Cost",
      value: "labourCost",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Total Cost",
      value: "totalCost",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "CGST Percentage",
      value: "cgstPercentage",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "SGST Percentage",
      value: "sgstPercentage",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Total Tax Percentage",
      value: "totalTaxPercentage",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Discount Amount",
      value: "discountAmount",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Discount Percentage",
      value: "discountPercentage",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Attachments",
      value: "attachments",
      type: "file",
      disabled: false,
      subCategory: null,
    },
  ];

  // const columns = [
  //   {
  //     field: "id",
  //     headerName: "Id",
  //     minWidth: 100,
  //     align: "start",
  //     sortable: false,
  //   },
  //   {
  //     field: "batteryid",
  //     headerName: "Battery ID",
  //     minWidth: 250,
  //     align: "start",
  //     sortable: false,
  //   },
  //   {
  //     field: "manufacturerName",
  //     headerName: "Manufacturer Name",
  //     minWidth: 200,
  //     align: "start",
  //     sortable: false,
  //   },
  //   {
  //     field: "purchaseDate",
  //     headerName: "Purchase Date",
  //     minWidth: 150,
  //     align: "start",
  //   },
  //   {
  //     field: "isActive",
  //     headerName: "Is Active",
  //     minWidth: 190,
  //     align: "start",
  //   },
  //   {
  //     field: "warrantyPeriod",
  //     headerName: "Warranty Period",
  //     minWidth: 150,
  //     align: "start",
  //     sortable: false,
  //   },
  //   {
  //     field: "warrantyStartDate",
  //     headerName: "Warranty Start Date",
  //     minWidth: 150,
  //     align: "start",
  //   },
  //   {
  //     field: "warrantyEndDate",
  //     headerName: "Warranty End Date",
  //     minWidth: 150,
  //     align: "start",
  //   },
  //   {
  //     field: "isInstalled",
  //     headerName: "is Insalled",
  //     minWidth: 150,
  //     align: "start",
  //   },
  //   {
  //     field: "dateOfInstallation",
  //     headerName: "Date of Installation",
  //     minWidth: 150,
  //     align: "start",
  //   },
  //   {
  //     field: "isSwapped",
  //     headerName: "Is Swapped",
  //     minWidth: 150,
  //     align: "start",
  //   },
  //   {
  //     field: "swappedFromVehicleId",
  //     headerName: "Swapped From Vehicle ID",
  //     minWidth: 150,
  //     align: "start",
  //   },
  //   {
  //     field: "vendorName",
  //     headerName: "Vendor Name",
  //     minWidth: 150,
  //     align: "start",
  //   },
  //   {
  //     field: "vendorContact",
  //     headerName: "Vendor Contact",
  //     minWidth: 150,
  //     align: "start",
  //   },
  //   {
  //     field: "vendorAddress",
  //     headerName: "Vendor Address",
  //     minWidth: 150,
  //     align: "start",
  //   },
  //   {
  //     field: "edit",
  //     headerName: "Edit",
  //     minWidth: 150,
  //     align: "start",
  //     renderCell: (params) => (
  //       <Button
  //         sx={{ color: "white", bgcolor: "#1227e6", fontWeight: 700 }}
  //         onClick={() => handleEdit(params.row)}
  //       >
  //         Edit
  //       </Button>
  //     ),
  //   },
  // ];

  // Helper function to convert formatted date (e.g., "20-Jan-2026 12:00 AM") to YYYY-MM-DD
  const formatDateToInput = (dateString) => {
    if (!dateString) return "";

    // Handle ISO format (2026-01-20T00:00:00)
    if (dateString.includes("T")) {
      return dateString.split("T")[0];
    }

    // Handle formatted date (20-Jan-2026 12:00 AM)
    const months = {
      jan: "01",
      feb: "02",
      mar: "03",
      apr: "04",
      may: "05",
      jun: "06",
      jul: "07",
      aug: "08",
      sep: "09",
      oct: "10",
      nov: "11",
      dec: "12",
    };

    const parts = dateString.split(" ");
    const dateParts = parts[0].split("-");

    if (dateParts.length === 3) {
      const day = dateParts[0].padStart(2, "0");
      const month = months[dateParts[1].toLowerCase()] || dateParts[1];
      const year = dateParts[2];
      return `${year}-${month}-${day}`;
    }

    return dateString;
  };

  const handleEdit = (row) => {
    setHideTestFields(true);
    setIsEdit(true);
    setEditWindShieldId(row.id);

    const rawWindShieldData = windShieldData.find((b) => b.id === row.id);

    // Parse attachments if it's a JSON string
    let parsedAttachments = [];
    try {
      const attachmentsData =
        row?.attachments || rawWindShieldData?.attachments;
      if (typeof attachmentsData === "string") {
        parsedAttachments = JSON.parse(attachmentsData);
      } else if (Array.isArray(attachmentsData)) {
        parsedAttachments = attachmentsData;
      }
    } catch (e) {
      parsedAttachments = [];
    }

    setForm({
      newGlassId: row?.newGlassId || rawWindShieldData?.newGlassId || "",
      oldPartNumber:
        rawWindShieldData?.oldPartNumber || row?.oldPartNumber || "",

      glassPosition:
        row?.glassPosition || rawWindShieldData?.glassPosition || "",
      actionType: row?.actionType || rawWindShieldData?.actionType || "",
      initialCondition:
        row?.initialCondition || rawWindShieldData?.initialCondition,
      damageLocation:
        row?.damageLocation || rawWindShieldData?.damageLocation || null,
      replacementReason:
        row?.replacementReason || rawWindShieldData?.replacementReason || null,
      attachments: parsedAttachments,
      costToCompany:
        row?.costToCompany || rawWindShieldData?.costToCompany || null,
      sgst: row?.sgst || rawWindShieldData?.sgst || null,
      cgst: row?.cgst || rawWindShieldData?.cgst || null,
      totalTax: row?.totalTax || rawWindShieldData?.totalTax || null,
      labourCost: row?.labourCost || rawWindShieldData?.labourCost || null,
      totalCost: row?.totalCost || rawWindShieldData?.totalCost || null,
      sgstPercentage:
        row?.sgstPercentage || rawWindShieldData?.sgstPercentage || null,
      cgstPercentage:
        row?.cgstPercentage || rawWindShieldData?.cgstPercentage || null,
      totalTaxPercentage:
        row?.totalTaxPercentage ||
        rawWindShieldData?.totalTaxPercentage ||
        null,
      discountAmount:
        row?.discountAmount || rawWindShieldData?.discountAmount || null,
      discountPercentage:
        row?.discountPercentage ||
        rawWindShieldData?.discountPercentage ||
        null,
    });

    // Set uploaded images for preview
    if (row?.attachments) {
      try {
        const attachments =
          typeof row.attachments === "string"
            ? JSON.parse(row.attachments)
            : row.attachments;
        setUploadedImages(attachments);
      } catch (e) {
        setUploadedImages(row?.attachments || null);
      }
    }

    // Scroll to the form section
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 0);
  };

  const rows =
    (windShieldData &&
      windShieldData?.map((item) =>
        createData(
          item?.id,
          item?.attachments,
          item?.glassPosition,
          item?.actionType,
          item?.initialCondition,
          item?.damageLocation,
          item?.oldPartNumber,
          item?.newGlassId,
          item?.replacementReason,
          item?.costToCompany,
          item?.sgst,
          item?.cgst,
          item?.totalTax,
          item?.labourCost,
          item?.totalCost,
          item?.sgstPercentage,
          item?.cgstPercentage,
          item?.totalTaxPercentage,
          item?.discountAmount,
          item?.discountPercentage,
          formatDateAndTime(item?.createdAt),
        ),
      )) ||
    [];

  const getVehicleWindShieldDetails = async (id, page = 0, pageSize = 20) => {
    const limit = pageSize;
    const offset = page * pageSize;

    try {
      setLoading(true);

      const response = await fetch(
        `${apiUrl}/api/windshieldservicelogs?vehicleId=${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );

      const data = await response.json();

      if (data?.statusCode === "0100") {
        setWindShieldData(data?.entities?.rows || []);
        setTotalCount(data?.entities?.count || 0);
      }

      return data;
    } catch (error) {
      console.error("Error fetching NRK listings:", error);
    } finally {
      setLoading(false);
    }
  };

  //   const getVehicleIssues = async (vehicleID, page = 0, pageSize = 20) => {
  //     const limit = pageSize;
  //     const offset = page * pageSize;

  //     try {
  //       setLoading(true);

  //       const response = await fetch(
  //         `${apiUrl}/api/vehicleissues?limit=${limit}&offset=${offset}&vehicleId=${vehicleID}`,
  //         {
  //           method: "GET",
  //         },
  //       );

  //       const data = await response.json();

  //       if (data?.statusCode === "0100") {
  //         setMyIssuesDetails(data?.entities?.rows || []);
  //       }

  //       return data;
  //     } catch (error) {
  //       console.error("Error fetching NRK listings:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   const getVehicleAPI = async () => {
  //     try {
  //       const response = await fetch(
  //         `${apiUrl}/api/vehicles?limit=${1000}&offset=${0}`,
  //         {
  //           method: "GET",
  //         },
  //       );

  //       const data = await response.json();

  //       if (data?.statusCode === "0100") {
  //         setVehicles(data?.entities?.rows || []);
  //       }

  //       return data;
  //     } catch (error) {
  //       console.error("Error fetching NRK listings:", error);
  //     }
  //   };

  useEffect(() => {
    if (selectedRow) {
      getVehicleWindShieldDetails(
        selectedRow.id,
        paginationModel.page,
        paginationModel.pageSize,
      );
    }
  }, [selectedRow]);

  const handleChange = async (field, value) => {
    if (field === "attachments") {
      await uploadmutiplefile(value, "vehicles", "vehicle").then((res) => {
        let filterImages = res?.uploaded?.map((image) => image?.url);
        setUploadedImages((prev) => {
          if (!prev || prev.length === 0) {
            return filterImages; // first upload
          }
          return [...prev, ...filterImages]; // append
        });
        setForm((prev) => ({
          ...prev,
          [field]: res?.uploaded || "",
        }));
      });
    } else {
      setForm((prev) => ({ ...prev, [field]: value }));
    }
  };

  const validateForm = () => {
    let newErrors = {};

    // Battery ID
    if (!form.batteryId?.trim()) {
      newErrors.batteryId = "Battery ID is required";
    }

    // Date of Manufacturing
    if (!form.dateOfManufacturing) {
      newErrors.dateOfManufacturing = "Manufacturing date is required";
    } else if (new Date(form.dateOfManufacturing) > new Date()) {
      newErrors.dateOfManufacturing = "Manufacturing date cannot be future";
    }

    // Manufactured By
    if (!form.manufacuturedBy?.trim()) {
      newErrors.manufacuturedBy = "Manufacturer name is required";
    }

    // Warranty
    if (!form.warrantyPeriod) {
      newErrors.warrantyPeriod = "Warranty period is required";
    } else if (Number(form.warrantyPeriod) <= 0) {
      newErrors.warrantyPeriod = "Warranty must be greater than 0";
    }

    // Start Date
    if (!form.startDate) {
      newErrors.startDate = "Start date is required";
    } else if (
      form.dateOfManufacturing &&
      new Date(form.startDate) < new Date(form.dateOfManufacturing)
    ) {
      newErrors.startDate = "Start date must be after manufacturing date";
    }

    // End Date
    if (!form.endDate) {
      newErrors.endDate = "End date is required";
    } else if (
      form.startDate &&
      new Date(form.endDate) < new Date(form.startDate)
    ) {
      newErrors.endDate = "End date must be after start date";
    }

    // Is Installed
    if (form.isInstalled === undefined) {
      newErrors.isInstalled = "Please select installation status";
    }

    // Installed Date (only if installed)
    if (form.isInstalled === "true" && !form.installedDate) {
      newErrors.installedDate = "Installed date is required";
    }

    // Is Swapped
    if (form.isSwapped === undefined) {
      newErrors.isSwapped = "Please select swap status";
    }

    // Attachments
    if (!form.attachments || form.attachments.length === 0) {
      newErrors.attachments = "At least one attachment is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleAddNewBattery = async () => {
    let payload = {};
    if (editWindShield) {
      payload = {
        id: editWindShield?.id,
        glassPosition: form?.glassPosition,
        actionType: form?.actionType,
        initialCondition: form?.initialCondition,
        damageLocation: form?.damageLocation,
        oldPartNumber: form?.oldPartNumber,
        newGlassId: form?.newGlassId,
        replacementReason: form?.replacementReason,
        vehicleId: selectedRow?.id,
        attachments: JSON.stringify(form?.attachments),
        costToCompany: Number(form?.costToCompany),
        serviceLogId: selectedRow?.id,
        isArchieved: false,
        sgst: form?.sgst,
        cgst: form?.cgst,
        totalTax: form?.totalTax,
        labourCost: form?.labourCost,
        totalCost: form?.totalCost,
        sgstPercentage: form?.sgstPercentage,
        cgstPercentage: form?.cgstPercentage,
        totalTaxPercentage: form?.totalTaxPercentage,
        discountAmount: form?.discountAmount,
        discountPercentage: form?.discountPercentage,
      };
    } else {
      payload = {
        // id: selectedRow?.id,
        glassPosition: form?.glassPosition,
        actionType: form?.actionType,
        initialCondition: form?.initialCondition,
        damageLocation: form?.damageLocation,
        oldPartNumber: form?.oldPartNumber,
        newGlassId: form?.newGlassId,
        replacementReason: form?.replacementReason,
        vehicleId: selectedRow?.id,
        attachments: JSON.stringify(form?.attachments),
        costToCompany: Number(form?.costToCompany),
        serviceLogId: selectedRow?.id,
        isArchieved: false,
        sgst: form?.sgst,
        cgst: form?.cgst,
        totalTax: form?.totalTax,
        labourCost: form?.labourCost,
        totalCost: form?.totalCost,
        sgstPercentage: form?.sgstPercentage,
        cgstPercentage: form?.cgstPercentage,
        totalTaxPercentage: form?.totalTaxPercentage,
        discountAmount: form?.discountAmount,
        discountPercentage: form?.discountPercentage,
      };
    }
    try {
      const response = await fetch(`${apiUrl}/api/windshieldservicelogs`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setForm({});
        setUploadedImages(null);
        toast.success("New Wind Shield Details Updated Successfully", {
          position: "bottom-center",
          style: {
            background: "blue", // override background
            color: "white",
            fontWeight: "medium",
            marginBottom: "50px",
          },
        });
        setErrors({});
        setEditWindShieldId(null);
        setIsEdit(false);
        getVehicleWindShieldDetails(
          selectedRow.id,
          paginationModel.page,
          paginationModel.pageSize,
        );
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching POST vehicle details:", error);
    }
  };

  return (
    <>
      <div className="flex justify-between p-6 mt-6">
        <h1 className="text-lg font-semibold">Add Wind Shield Details</h1>{" "}
        {hideTextfields ? (
          <CloseIcon
            className="cursor-pointer"
            onClick={() => {
              setHideTestFields(false);
            }}
          />
        ) : (
          <AddCircleOutlineIcon
            className="cursor-pointer"
            onClick={() => {
              setHideTestFields(true);
            }}
          />
        )}
      </div>
      {hideTextfields && (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 p-6 rounded-lg">
            {generalInformationofBatteries.map((field, index) => (
              <div key={index} className="group">
                <label className="block mb-2 font-semibold text-gray-700 text-sm">
                  {field.label}
                  {field.required && (
                    <span className="text-red-500 ml-1">*</span>
                  )}
                </label>

                {/* DROPDOWN */}
                {field.type === "dropdown" && (
                  <FormControl fullWidth size="small">
                    <InputLabel id={`select-label-${index}`}>
                      {field.label}
                    </InputLabel>

                    <Select
                      labelId={`select-label-${index}`}
                      value={form[field.value] || ""}
                      label={field.label}
                      disabled={field.disabled}
                      onChange={(e) =>
                        handleChange(field.value, e.target.value)
                      }
                      sx={{
                        borderRadius: "8px",
                        backgroundColor: field.disabled ? "#f3f4f6" : "#fff",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#e5e7eb",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#6366f1",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#4f46e5",
                        },
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            maxHeight: 240,
                            borderRadius: "8px",
                          },
                        },
                      }}
                    >
                      {field?.subCategory
                        ?.filter((opt) => opt.item !== "inverted")
                        .map((option, idx) => (
                          <MenuItem
                            key={idx}
                            value={option.key ?? option.label ?? option.value}
                          >
                            {option.value}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                )}

                {/* FILE UPLOAD */}
                {field.type === "file" && (
                  <div className="space-y-2">
                    <Button
                      component="label"
                      variant="outlined"
                      fullWidth
                      disabled={field.disabled}
                      startIcon={<Upload size={18} />}
                      sx={{
                        borderStyle: "dashed",
                        borderRadius: "8px",
                        padding: "12px",
                        color: "#4f46e5",
                        borderColor: "#a5b4fc",
                        "&:hover": {
                          borderColor: "#6366f1",
                          backgroundColor: "#eef2ff",
                        },
                      }}
                    >
                      {form[field.value]?.length
                        ? "Change Files"
                        : "Upload Files"}
                      <input
                        hidden
                        type="file"
                        multiple
                        accept="image/*"
                        onChange={(e) =>
                          handleChange(field.value, e.target.files)
                        }
                      />
                    </Button>
                  </div>
                )}

                {/* TEXT / NUMBER / DATE */}
                {field.type !== "dropdown" && field.type !== "file" && (
                  <TextField
                    fullWidth
                    size="small"
                    type={field.type}
                    value={form[field.value] || ""}
                    disabled={field.disabled}
                    onChange={(e) => handleChange(field.value, e.target.value)}
                    placeholder={`Enter ${field.label.toLowerCase()}`}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "8px",
                        backgroundColor: field.disabled ? "#f3f4f6" : "#fff",
                      },
                    }}
                  />
                )}
              </div>
            ))}
          </div>
          {uploadedImages && (
            <div className="grid grid-cols-1 bg-white p-4 rounded-lg">
              {uploadedImages?.length > 0 ? (
                <div className="mt-6 flex gap-4 flex-wrap">
                  {uploadedImages.map((image, index) => (
                    <img
                      key={index}
                      src={
                        image?.url || image?.Location || image?.path || image
                      }
                      alt="Image Preview"
                      className="w-28 h-28 rounded-lg object-cover border shadow"
                    />
                  ))}
                </div>
              ) : (
                <div className="mt-6 flex gap-4 flex-wrap">
                  <img
                    src={uploadedImages}
                    alt="Image Preview"
                    className="w-44 h-44 rounded-lg object-cover border shadow"
                  />
                </div>
              )}
            </div>
          )}
          <div className="flex justify-end p-6">
            {Object.keys(errors).length > 0 && (
              <div className="text-red-600 text-sm mb-4">
                <ul className="list-disc pl-5">
                  {Object.values(errors).map((err, index) => (
                    <li key={index}>{err}</li>
                  ))}
                </ul>
              </div>
            )}

            <button
              onClick={() => {
                // if (!validateForm()) return;
                handleAddNewBattery();
              }}
              className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700
  text-white font-semibold px-5 py-2.5 rounded-lg shadow-md"
            >
              {isEdit ? "Update" : "+ Add"}
            </button>
          </div>{" "}
        </>
      )}

      <div className="p-4">
        {/* <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
            className="shadow-lg rounded-lg"
          >
            <div className="flex items-center w-full">

              <div className="ml-auto mr-10">                
              </div>
            </div>
          </AccordionSummary>

          <AccordionDetails> */}
        <TableContainer
          component={Paper}
          sx={{
            width: "100%",
            overflowX: "auto",
            borderRadius: 2,
          }}
        >
          <Table sx={{ minWidth: 2200 }}>
            <TableHead>
              <TableRow>
                <TableCell>Attachments</TableCell>
                <TableCell>Glass Position</TableCell>
                <TableCell>Action Type</TableCell>
                <TableCell>Initial Condition</TableCell>
                <TableCell>Damage Location</TableCell>
                <TableCell>Old Part Number</TableCell>
                <TableCell>New Glass ID</TableCell>
                <TableCell>Replacement Reason</TableCell>
                <TableCell>Cost To Company</TableCell>
                <TableCell>Total Cost</TableCell>
                <TableCell>SGST Amount</TableCell>

                <TableCell>CGST Amount</TableCell>
                <TableCell>Total Tax</TableCell>

                <TableCell>Labour Cost</TableCell>
                <TableCell>SGST %</TableCell>
                <TableCell>CGST %</TableCell>
                <TableCell>Total Tax %</TableCell>

                <TableCell>Discount Amount</TableCell>
                <TableCell>Discount %</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {rows.length > 0 ? (
                <>
                  {rows.map((r, index) => (
                    <React.Fragment key={r.id || index}>
                      <TableRow hover>
                        {/* Attachments */}
                        <TableCell>
                          <IconButton
                            size="small"
                            onClick={() => setOpen(open === index ? -1 : index)}
                          >
                            {open === index ? (
                              <KeyboardArrowUpIcon />
                            ) : (
                              <KeyboardArrowDownIcon />
                            )}
                          </IconButton>
                        </TableCell>

                        {/* Glass Details */}
                        <TableCell>{r.glassPosition || "-"}</TableCell>
                        <TableCell>{r.actionType || "-"}</TableCell>
                        <TableCell>{r.initialCondition || "-"}</TableCell>
                        <TableCell>{r.damageLocation || "-"}</TableCell>
                        <TableCell>{r.oldPartNumber || "-"}</TableCell>
                        <TableCell>{r.newGlassId || "-"}</TableCell>
                        <TableCell>{r.replacementReason || "-"}</TableCell>
                        <TableCell>{r.costToCompany || "-"}</TableCell>
                        <TableCell>{r.totalCost ?? "-"}</TableCell>
                        {/* Tax */}
                        <TableCell>{r.sgst ?? "-"}</TableCell>
                        <TableCell>{r.cgst ?? "-"}</TableCell>
                        <TableCell>{r.totalTax ?? "-"}</TableCell>

                        {/* Cost */}
                        <TableCell>{r.labourCost ?? "-"}</TableCell>

                        {/* Percentage */}
                        <TableCell>
                          {r.sgstPercentage ?? "-"}
                          {r.sgstPercentage != null ? "%" : ""}
                        </TableCell>

                        <TableCell>
                          {r.cgstPercentage ?? "-"}
                          {r.cgstPercentage != null ? "%" : ""}
                        </TableCell>

                        <TableCell>
                          {r.totalTaxPercentage ?? "-"}
                          {r.totalTaxPercentage != null ? "%" : ""}
                        </TableCell>

                        {/* Discount */}
                        <TableCell>{r.discountAmount ?? "-"}</TableCell>

                        <TableCell>
                          {r.discountPercentage ?? "-"}
                          {r.discountPercentage != null ? "%" : ""}
                        </TableCell>
                        {r?.rawData?.serviceLogId &&
                        r?.rawData?.serviceLogId !== 0 ? (
                          <TableCell>
                            <Button
                              onClick={() => {
                                const navigate = `/workorder?orderid=${r?.rawData?.serviceLogId}&display=true`;
                                window.open(navigate, "_blank");
                              }}
                            >
                              View
                            </Button>
                          </TableCell>
                        ) : null}
                      </TableRow>

                      {/* Attachment Collapse Row */}
                      <TableRow>
                        <TableCell colSpan={20} sx={{ p: 0, borderBottom: 0 }}>
                          <Collapse
                            in={open === index}
                            timeout="auto"
                            unmountOnExit
                          >
                            <Box sx={{ p: 2 }}>
                              <Typography
                                variant="subtitle1"
                                fontWeight="bold"
                                mb={2}
                              >
                                Attachments
                              </Typography>

                              <Box
                                sx={{
                                  display: "flex",
                                  gap: 2,
                                  flexWrap: "wrap",
                                }}
                              >
                                {r.attachments ? (
                                  (() => {
                                    try {
                                      const files =
                                        typeof r.attachments === "string"
                                          ? JSON.parse(r.attachments)
                                          : r.attachments;

                                      return Array.isArray(files) &&
                                        files.length > 0 ? (
                                        files.map((file, i) => {
                                          const imageUrl =
                                            file?.url ||
                                            file?.Location ||
                                            file?.image ||
                                            file?.path;

                                          return (
                                            <img
                                              key={i}
                                              src={imageUrl}
                                              alt={`attachment-${i}`}
                                              onClick={() =>
                                                handleImageOpen(imageUrl)
                                              }
                                              style={{
                                                width: 150,
                                                height: 150,
                                                objectFit: "cover",
                                                cursor: "pointer",
                                                borderRadius: 8,
                                              }}
                                            />
                                          );
                                        })
                                      ) : (
                                        <Typography color="error">
                                          No Attachments
                                        </Typography>
                                      );
                                    } catch {
                                      return (
                                        <Typography color="error">
                                          No Attachments
                                        </Typography>
                                      );
                                    }
                                  })()
                                ) : (
                                  <Typography color="error">
                                    No Attachments
                                  </Typography>
                                )}
                              </Box>
                            </Box>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  ))}
                </>
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={20}
                    align="center"
                    sx={{
                      fontWeight: "bold",
                      py: 3,
                    }}
                  >
                    No Glass Details Found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {/* </AccordionDetails>
        </Accordion> */}
      </div>
      {previewOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50"
          onClick={() => setPreviewOpen(false)}
        >
          <img
            src={previewImage}
            className="max-h-[90%] max-w-[90%] rounded-lg shadow-lg"
          />
        </div>
      )}
    </>
  );
};

export default Mywindshield;
